// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__YDpXD","filesListContainer":"PosDisputesFiles_filesListContainer__2gaTm","filesButton":"PosDisputesFiles_filesButton__3fILf"};